"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cuneo": {
    "df2c310a": [{
      "hkey": "c48eae6d",
      "slug": "san-rocco-castagnaretta",
      "name": "San Rocco Castagnaretta",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "c48eae6d",
      "slug": "san-rocco-castagnaretta",
      "name": "San Rocco Castagnaretta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "66cd483f": [{
      "hkey": "6d998164",
      "slug": "borgo-san-giuseppe-roata-canale-spinetta",
      "name": "Borgo San Giuseppe-Roata Canale-Spinetta",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-san-giuseppe-madonna-delle-grazie-spinetta": [{
      "hkey": "6d998164",
      "slug": "borgo-san-giuseppe-roata-canale-spinetta",
      "name": "Borgo San Giuseppe-Roata Canale-Spinetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ff1aeb6e": [{
      "hkey": "853cef35",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-citta": [{
      "hkey": "853cef35",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cuneo"
    }],
    "24bfd345": [{
      "hkey": "50983be4",
      "slug": "madonna-dell-olmo",
      "name": "Madonna dell'Olmo",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-dell-olmo-ronchi-cascina-roero": [{
      "hkey": "50983be4",
      "slug": "madonna-dell-olmo",
      "name": "Madonna dell'Olmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8e6762d1": [{
      "hkey": "792d4dd8",
      "slug": "roata-rossi-passatore-san-pietro-del-gallo",
      "name": "Roata Rossi-Passatore-San Pietro del Gallo",
      "primary": true,
      "skipSearch": false
    }],
    "roata-rossi-passatore-san-benigno": [{
      "hkey": "792d4dd8",
      "slug": "roata-rossi-passatore-san-pietro-del-gallo",
      "name": "Roata Rossi-Passatore-San Pietro del Gallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "98bb54f5": [{
      "hkey": "d3888a25",
      "slug": "donatello-gramsci",
      "name": "Donatello-Gramsci",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo-donatello-gramsci": [{
      "hkey": "d3888a25",
      "slug": "donatello-gramsci",
      "name": "Donatello-Gramsci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;